<template>
  <Dialog v-model:open="open" :title="title" content-class="w-90" @update:open="onOpenChange">
    <div class="py-2 text-m-medium text-text-glass-default whitespace-pre-line">
      {{ content }}
    </div>
    <template #footer>
      <div class="flex gap-2 justify-end">
        <Button color="black" type="button" @click="onConfirm">
          {{ confirmLabel }}
        </Button>
        <Button v-if="allowDismiss" color="text-b-w" type="button" @click="onDismiss">
          {{ dismissLabel }}
        </Button>
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { Button, Dialog } from '@rapoo/element'

  withDefaults(
    defineProps<{
      /** 进入设备提示可「不再显示」；配置页强制提醒时关闭 */
      allowDismiss?: boolean
    }>(),
    { allowDismiss: true },
  )

  const emit = defineEmits<{
    confirm: []
    dismiss: []
  }>()

  const { t } = useI18n()
  const open = ref(true)
  const title = computed(() => t('performance.reportRate16k.usb2.title'))
  const content = computed(() => t('performance.reportRate16k.usb2.content'))
  const confirmLabel = computed(() => t('common.confirm'))
  const dismissLabel = computed(() => t('common.noDisabled'))

  let settled = false

  function finish(kind: 'confirm' | 'dismiss') {
    if (settled) return
    settled = true
    open.value = false
    if (kind === 'dismiss') emit('dismiss')
    else emit('confirm')
  }

  function onConfirm() {
    finish('confirm')
  }

  function onDismiss() {
    finish('dismiss')
  }

  function onOpenChange(next: boolean) {
    if (next) return
    finish('confirm')
  }
</script>
